import {createAction} from 'web-app/util/redux/typed-action-helpers';
import {type NonEmptyArray} from 'web-app/util/non-empty-array';
import {type ObservationVariant} from 'web-app/util/graphql/api-types';

export type ShowPayloadType =
    | {mode: 'new'; childIds?: NonEmptyArray<string>; variant: ObservationVariant}
    | {mode: 'edit'; observationId: string};

export type PreviewPayloadType = {curriculumId: string; siteSetId: string};

export const {action: show} = createAction('OBSERVATION_EDITOR_MODAL/SHOW', (payload: ShowPayloadType) => payload);
export const {action: resetState} = createAction('OBSERVATION_EDITOR_MODAL/RESET_STATE', () => ({}));

export const {action: preview} = createAction(
    'OBSERVATION_EDITOR_MODAL/PREVIEW',
    (payload: PreviewPayloadType) =>
        ({
            ...payload,
            mode: 'preview',
        } as {curriculumId: string; mode: 'preview'; siteSetId: string}),
);

export const {action: promptOfflineDraft} = createAction('OBSERVATION_EDITOR_MODAL/PROMPT_OFFLINE_DRAFT', () => ({}));
